<template>
  <bvue-ui-view class="flex flex-col w-full" :scroll="true">
    <h1 class="flex-1">Árbol</h1>
    <div class="form-group flex-1">
      <label>Latitud</label>
      <input type="number" class="form-input" step=".000000000000000001" v-model="item.position.lat" :disabled="!modalData.editable">
    </div>
    <div class="form-group flex-1">
      <label>Longitud</label>
      <input type="number" class="form-input" step=".000000000000000001" v-model="item.position.lng" :disabled="!modalData.editable">
    </div>
    <div class="form-group flex-1">
      <label>Altitud</label>
      <input type="number" class="form-input" step=".001" v-model="item.position.alt" :disabled="!modalData.editable">
    </div>
    <div class="form-group flex-1">
      <label>Accuracy</label>
      <input type="number" class="form-input" step=".01" v-model="item.position.accuracy" :disabled="!modalData.editable">
    </div>
    <div class="form-group flex-1">
      <label>Fecha de plantación</label>
      <input type="date" class="form-input" v-model="item.dateStr" :disabled="!modalData.editable">
    </div>
    <div class="form-group flex-1">
      <label>Especie</label>
      <select name="specie" class="form-select" v-model="item.specie" :disabled="!modalData.editable">
        <option v-for="specie in species" :value="specie.id" :key="specie.id">
          {{ specie.name }}
        </option>
      </select>
    </div>
    <div class=" flex my-4 justify-end">
      <button @click="remove" v-if="!isNew" :class="['btn', 'btn-error', deleting]" :disabled="!modalData.editable">Eliminar</button>
      <button @click="store" :class="['btn', 'btn-primary', 'ml-4', loading]" :disabled="!modalData.editable">{{isNew ? 'Crear' : 'Guardar'}}</button>
    </div>
  </bvue-ui-view>
</template>

<script>
import firebase from '@/firebase'
import { mapState } from 'vuex'
export default {
  name: 'TreeDetails',
  components: {  },
  props: {
    modalData: Object
  },
  data() {
    return {
      deleting: false,
      loading: false,
      colRef: null,
      isNew: true,
      loading: [],
      item: {position:{lat:0, lng:0, alt:0, accuracy: 0}}
    }
  },
  methods: {
    async store() {
      this.loading = ['loading', 'disabled']
      var item = this.item
      const id = this.item.id
      if (item.date && this.dateString(item.date) !== item.dateStr) {
        console.log('Date changed')
        item.date = new Date(item.dateStr).getTime()
      }
      item.csvLatLng = item.position.lat+''+item.position.lng
      delete item.dateStr
      delete item.id
      await this.colRef.doc(id).set(item)
      this.loading = []
      this.$bvueUi.modal.close()
    },
    async remove() {
      this.deleting = ['loading', 'disabled']
      await this.colRef.doc(this.item.id).delete()
      this.deleting = []
      this.$bvueUi.modal.close()
    },
    dateString(dateStr) {
      var d = new Date(dateStr),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
    }
  },
  computed: {
    ...mapState('species', {species: 'items'})
  },
  created() {
    console.log('this.modalData: ', this.modalData)
    this.colRef = this.modalData.colRef
    if (!this.colRef) {
      this.$bvueUi.modal.close()
      return
    }
    if (this.modalData && this.modalData.item.id) {
      this.isNew = false
      this.item = this.modalData.item
      this.item.dateStr = this.dateString(this.item.date)
    } else {
      this.item.id = this.colRef.doc().id
    }
    console.log('this.item: ', this.item)
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/admin/TreeDetails.vue